var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClutchLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 30,
    viewBox: "0 0 105 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41524_1329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1006 0H27.3203V30H32.1006V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8333 20.4301C48.8333 25.0213 44.9887 25.3873 43.845 25.3873C40.9876 25.3873 40.4678 22.7017 40.4678 21.0817V9.6001H35.6875V21.0577C35.6875 23.9017 36.5766 26.2489 38.135 27.8137C39.5117 29.1973 41.5744 29.9533 43.8092 29.9533C45.3939 29.9533 47.6382 29.4577 48.8333 28.3621V30.0001H53.6135V9.6001H48.8333V20.4301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1741 2.3999H58.3938V9.5999H54.8086V14.3999H58.3938V29.9999H63.1741V14.3999H66.7593V9.5999H63.1741V2.3999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8135 23.9006C80.7726 24.8402 79.3982 25.361 77.8901 25.361C74.5654 25.361 72.1238 22.9094 72.1238 19.5434C72.1238 16.1774 74.4877 13.829 77.8901 13.829C79.3719 13.829 80.7726 14.3246 81.8398 15.2642L82.5652 15.8906L85.7883 12.6554L84.9816 11.9246C83.085 10.205 80.567 9.24023 77.8889 9.24023C71.9135 9.24023 67.5742 13.5698 67.5742 19.5182C67.5742 25.4414 72.0175 29.9258 77.8889 29.9258C80.6172 29.9258 83.1615 28.961 85.0342 27.2138L85.8134 26.483L82.5401 23.2502L81.8135 23.9006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.848 11.3784C101.472 9.996 99.8583 9.24 97.6236 9.24C96.0389 9.24 94.2439 9.7356 93.0488 10.83V0H88.2686V30H93.0488V18.762C93.0488 14.1708 96.297 13.806 97.4407 13.806C100.298 13.806 100.219 16.4928 100.219 18.1104V30H105V18.1356C105 15.2916 104.408 12.9444 102.848 11.3784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7323 16.1255C79.642 16.1255 81.1896 17.6771 81.1896 19.5959C81.1896 21.5123 79.642 23.0663 77.7323 23.0663C75.8238 23.0663 74.2773 21.5123 74.2773 19.5959C74.2785 17.6783 75.825 16.1255 77.7323 16.1255Z",
    fill: "#FF3D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6281 22.465C18.8104 24.343 16.3414 25.3606 13.7433 25.3606C8.41807 25.3606 4.54604 21.1606 4.54604 15.3958C4.54604 9.60464 8.41807 5.40464 13.7433 5.40464C16.3163 5.40464 18.7578 6.42104 20.603 8.27384L21.3296 9.00464L24.5252 5.79584L23.8237 5.06504C21.1742 2.32544 17.589 0.839844 13.7433 0.839844C5.89767 0.839844 0 7.10024 0 15.421C0 23.7166 5.92396 29.9518 13.7433 29.9518C17.6153 29.9518 21.2005 28.4398 23.85 25.7002L24.5515 24.9694L21.3822 21.709L20.6281 22.465Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41524_1329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClutchLogo);
export default __webpack_public_path__ + "static/media/ClutchLogo.900cfe87a7372845a251b10d5aaf3c95.svg";
export { ForwardRef as ReactComponent };